export default __webpack_public_path__ + "static/media/404.93219686.webp";